import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20editorial%20flat%20lay%20composition%20featuring%20curated%20collection%20of%20neutral%20toned%20clothing%20items%20cream%20cashmere%20knit%20white%20leather%20sneakers%20beige%20linen%20trousers%20gold%20minimalist%20watch%20soft%20leather%20tote%20bag%20arranged%20artistically%20on%20warm%20cream%20textured%20backdrop%20gentle%20natural%20daylight%20from%20large%20window%20creating%20soft%20diffused%20shadows%20clean%20modern%20european%20boutique%20aesthetic%20harmonious%20organic%20composition%20professional%20high%20end%20commercial%20photography%20warm%20inviting%20atmosphere%20subtle%20depth%20fresh%20sophisticated%20look&width=1600&height=900&seq=hero-main-v5&orientation=landscape"
          alt="PandabuySpreadsheet curated fashion finds collection"
          title="PandabuySpreadsheet Fashion Collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 pt-16">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight tracking-tight">
            Pandabuy<span className="text-accent-400">Spreadsheet</span>
          </h1>
          <p className="mt-3 md:mt-4 text-base md:text-xl text-white/80 font-light leading-relaxed max-w-lg">
            The #1 Curated Pandabuy Spreadsheet Finder — Discover trending fashion, sneakers, accessories, and budget finds organized into beautiful spreadsheets. Updated daily for 2026.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white text-foreground-900 text-sm font-semibold rounded-full hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap group"
            >
              Pandabuy Sheet
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-accent-500 text-white text-sm font-semibold rounded-full hover:bg-accent-600 transition-all cursor-pointer whitespace-nowrap group"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
          </div>

          <Link
            to="/pandabuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 mt-6 text-sm text-white/70 hover:text-white transition-colors cursor-pointer group"
          >
            <span>Read the Complete Pandabuy Spreadsheet Guide</span>
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 right-0 w-1/3 hidden lg:flex gap-3 p-6 opacity-50">
        <div className="rounded-2xl overflow-hidden w-28 h-36">
          <img
            src="https://readdy.ai/api/search-image?query=Closeup%20of%20premium%20quality%20cream%20colored%20cashmere%20wool%20sweater%20with%20visible%20soft%20knit%20texture%20folded%20elegantly%20on%20light%20beige%20linen%20fabric%20gentle%20natural%20daylight%20from%20above%20clean%20minimalist%20fashion%20photography%20warm%20neutral%20tones%20editorial%20style%20soft%20shadows%20professional%20product%20shot%20sophisticated%20simple%20composition%20high%20detail%20luxurious%20feel&width=300&height=400&seq=hero-side-v5-a&orientation=portrait"
            alt="Premium fashion item"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="rounded-2xl overflow-hidden w-28 h-36 mt-10">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20structured%20leather%20handbag%20in%20warm%20cognac%20brown%20tone%20standing%20on%20soft%20cream%20surface%20natural%20daylight%20creating%20gentle%20reflection%20on%20leather%20minimalist%20accessory%20photography%20clean%20composition%20subtle%20gold%20hardware%20visible%20professional%20product%20shot%20refined%20sophisticated%20aesthetic%20neutral%20warm%20palette%20modern%20boutique%20style%20high%20detail%20soft%20shadows&width=300&height=400&seq=hero-side-v5-b&orientation=portrait"
            alt="Premium fashion item"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}